import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

/** True solo si las dos variables Supabase están definidas. Si está en false,
 *  el sitio usa los datos de fallback en `demoData.ts` y no hace llamadas de red. */
export const IS_SUPABASE_CONFIGURED = Boolean(url && anon && !url.includes('placeholder'));

if (!IS_SUPABASE_CONFIGURED) {
  console.info('[supabase] sin credenciales — usando datos demo locales. Define .env para conectar.');
}

// Los datos viven en el schema dedicado `polvillas` dentro del proyecto aova-brain.
// `db.schema` hace que supabase.from('products') apunte a polvillas.products.
// `auth.*` sigue usando el schema `auth` (no se ve afectado).
export const supabase = createClient(url ?? 'https://placeholder.supabase.co', anon ?? 'placeholder', {
  db: {
    schema: 'polvillas',
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: { eventsPerSecond: 5 },
  },
});

export const WA_NUMBER = import.meta.env.VITE_WA_NUMBER ?? '525653712507';
export const RH_EMAIL  = import.meta.env.VITE_RH_EMAIL  ?? 'rh@laspolvillas.mx';

export function waLink(text: string, number: string = WA_NUMBER): string {
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
